import script from "./DemandDayDelivery.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandDayDelivery.vue?vue&type=script&setup=true&lang=ts"

import "./DemandDayDelivery.vue?vue&type=style&index=0&id=617959cb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617959cb"]])

export default __exports__